import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    number: "01",
    title: "No Tow Trucks. No Waiting Rooms.",
    body: "Your driveway becomes the shop bay. Skip the hours lost in retail repair lobbies — our fully-equipped mobile unit handles complex diagnostics right at your home.",
  },
  {
    number: "02",
    title: "310S Master Technician Precision",
    body: "Every vehicle is serviced directly by a licensed Ontario 310S Automotive Service Technician — OEM-grade scanners, transparent explanations before any wrench turns.",
  },
  {
    number: "03",
    title: "Honest Rates. Zero Mystery Line Items.",
    body: "A clear, upfront pricing schedule for call-out diagnostics, routine maintenance, brake jobs, and under-hood work. You approve everything before we start.",
  },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="relative bg-obsidian py-16 sm:py-24 lg:py-32 noise-overlay">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-ember mb-4">The GoGo Manifesto</p>
        <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none max-w-3xl">
          A repair shop that <span className="text-ember">shows up.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.number} delay={i * 0.12} className="bg-obsidian">
            <div className="p-8 lg:p-10 h-full group hover:bg-charcoal transition-colors duration-300" data-testid={`manifesto-chapter-${c.number}`}>
              <span className="font-display font-black text-6xl lg:text-7xl text-stroke-green group-hover:text-ember group-hover:[-webkit-text-stroke:0px] transition-all duration-300">
                {c.number}
              </span>
              <h3 className="mt-6 font-display font-bold uppercase text-2xl tracking-tight leading-tight">
                {c.title}
              </h3>
              <p className="mt-4 text-mist text-sm leading-relaxed">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
